import axios from "axios"
import config from "config/config"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  FormFeedback,
  Alert,
} from "reactstrap"
import PrimaryButton from "newcomponents/primary-button"

const MFAInput = ({ isOpen, toggle, onSubmit, error }) => {
  const [code, setCode] = useState("")
  const [password, setPassword] = useState("")
  const [touched, setTouched] = useState(false)
  const userData = useSelector(state => state.Login.userData)
  const mode = useSelector(state => state.Layout.layoutMode)

  const handleSubmit = e => {
    e.preventDefault()
    setTouched(true)
    if (userData?.twoFactorEnabled) {
      if (code.trim() === "") return
      onSubmit(code)
    } else {
      if (password.trim() === "") return
      onSubmit(password)
    }
  }

  const sendEmailMFA = async () => {
    await axios.post(`${config.backendUrl}/auth/sendMFA`, {
      userId: userData.id,
    })
  }

  useEffect(() => {
    if (
      isOpen &&
      userData?.twoFactorEnabled &&
      userData.twoFactorMethod === "Email"
    ) {
      sendEmailMFA()
    }
  }, [isOpen])

  const isEmailMFA =
    userData?.twoFactorEnabled && userData.twoFactorMethod === "Email"

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      style={{ maxWidth: "500px" }}
    >
      <div
        style={{
          backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
          borderRadius: "12px",
          padding: "0",
        }}
      >
        {/* Header */}
        <ModalHeader
          toggle={toggle}
          style={{
            backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
            color: mode === "dark" ? "#fff" : "#000",
            fontWeight: "600",
            fontSize: "18px",
            borderBottom:
              mode === "dark" ? "1px solid #374151" : "1px solid #e5e7eb",
            paddingBottom: "16px",
          }}
        >
          {isEmailMFA ? "Enter 2FA Code" : "Enter Password"}
        </ModalHeader>

        {/* Body */}
        <ModalBody
          style={{
            backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
            textAlign: "center",
            padding: "30px 40px",
          }}
        >
          <form onSubmit={handleSubmit}>
            <Label
              style={{
                color: mode === "dark" ? "#fff" : "#6c757d",
                fontWeight: 500,
                fontSize: "14px",
                textAlign: "left",
                display: "block",
                marginBottom: "6px",
              }}
              htmlFor={isEmailMFA ? "mfa-code" : "password"}
            >
              {isEmailMFA ? "2FA Code (Email)" : "Password"}
            </Label>

            <Input
              id={isEmailMFA ? "mfa-code" : "password"}
              type={isEmailMFA ? "text" : "password"}
              value={isEmailMFA ? code : password}
              onChange={e =>
                isEmailMFA
                  ? setCode(e.target.value)
                  : setPassword(e.target.value)
              }
              onBlur={() => setTouched(true)}
              placeholder={`Enter your ${isEmailMFA ? "2FA code" : "password"}`}
              invalid={
                touched &&
                (isEmailMFA ? code.trim() === "" : password.trim() === "")
              }
              autoFocus
              style={{
                backgroundColor: mode === "dark" ? "#374151" : "#f9fafb",
                border: mode === "dark" ? "1px solid #4b5563" : "1px solid #e5e7eb",
                color: mode === "dark" ? "#fff" : "#000",
              }}
            />

            {touched &&
              (isEmailMFA ? code.trim() === "" : password.trim() === "") && (
                <FormFeedback>
                  Please enter your {isEmailMFA ? "2FA code" : "password"}.
                </FormFeedback>
              )}

            {error && (
              <Alert color="danger" className="mt-2 mb-0">
                {error}
              </Alert>
            )}
          </form>
        </ModalBody>

        {/* Footer */}
        <ModalFooter
          style={{
            backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
            justifyContent: "center",
            gap: "12px",
            borderTop:
              mode === "dark" ? "1px solid #374151" : "1px solid #e5e7eb",
            padding: "16px 40px",
          }}
        >
          <PrimaryButton
            onClick={toggle}
            style={{
              backgroundColor: "white",
              border:
                mode === "dark" ? "1px solid #374151" : "1px solid #e0e0e0",
              color: mode === "dark" ? "#000" : "#000",
              fontSize: "16px",
              fontWeight: "500",
              width: "166px",
              height: "46px",
              borderRadius: "5px",
            }}
          >
            Cancel
          </PrimaryButton>

          <PrimaryButton
            onClick={handleSubmit}
            style={{
              backgroundColor: "#2990DF",
              color: "#fff",
              fontSize: "14px",
              fontWeight: "500",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              width: "166px",
              height: "46px",
              borderRadius: "5px",
              textTransform: "none",
            }}
          >
            Submit
          </PrimaryButton>
        </ModalFooter>
      </div>
    </Modal>
  )
}

export default MFAInput
